const ab = {
  // ==================== AUFTRAGSBESTÄTIGUNG ERFASSEN ====================
  'ab.title': 'Auftragsbestätigung erfassen',
  'ab.subtitle': 'AB-PDF hochladen, Positionen prüfen und gegen die Bestellung abgleichen',
  'ab.inDevelopmentDesc': 'Die Auftragsbestätigungs-Erfassung wird die AB des Lieferanten automatisch per OCR auslesen und KI-gestützt gegen die zugehörige MM-Bestellung prüfen (Menge, Preis, Liefertermin) — inklusive Abweichungs-Hinweisen und Freigabe-Workflow.',

  // ---- Header/Kopfbereich ----
  'ab.uploadButton': 'Hochladen',
  'ab.uploadHide': 'Ausblenden',
  'ab.ocrUnreachable': 'OCR-Dienst nicht erreichbar',

  // ---- KPI-Kacheln ----
  'ab.kpiNeedsReview': 'Zu prüfen',
  'ab.kpiNoRuleset': 'Ohne Regelset',
  'ab.kpiFailed': 'Fehlgeschlagen',
  'ab.kpiApproved7d': 'Freigegeben (7 Tage)',

  // ---- Upload-Dropzone ----
  'ab.uploadDropzoneTitle': 'AB-PDF hier ablegen',
  'ab.uploadDropzoneHint': 'oder Datei auswählen — nur PDF, max. 20 MB',
  'ab.uploadBusy': 'Wird hochgeladen und verarbeitet…',
  'ab.uploadOk': 'Hochgeladen — {n} Position(en) erkannt',
  'ab.uploadError': 'Upload fehlgeschlagen',
  'ab.uploadOnlyPdf': 'Nur PDF-Dateien werden unterstützt',
  'ab.uploadTooLarge': 'Datei ist zu groß (max. 20 MB)',

  // ---- Dokumentenliste ----
  'ab.tabOpen': 'Offen',
  'ab.tabDone': 'Erledigt',
  'ab.searchPlaceholder': 'Datei, Lieferant oder Bestellnummer suchen…',
  'ab.refresh': 'Aktualisieren',
  'ab.colFile': 'Datei',
  'ab.colSupplier': 'Lieferant',
  'ab.colOrder': 'Bestellung',
  'ab.colLines': 'Positionen',
  'ab.colCompare': 'Abgleich',
  'ab.colWarnings': 'Warnungen',
  'ab.colStatus': 'Status',
  'ab.colCreated': 'Erstellt am',
  'ab.colPos': 'Pos.',
  'ab.supplierUnknown': 'Unbekannt',
  'ab.listEmpty': 'Keine Dokumente gefunden',
  'ab.listLoadError': 'Liste konnte nicht geladen werden',
  'ab.loading': 'Lädt…',
  'ab.pageInfo': 'Seite {page} von {totalPages} · {total} Dokument(e)',

  // ---- Status (Ampel, ab_documents.status) ----
  'ab.status.processing': 'In Verarbeitung',
  'ab.status.needs_review': 'Zu prüfen',
  'ab.status.no_ruleset': 'Kein Regelset',
  'ab.status.failed': 'Fehlgeschlagen',
  'ab.status.approved': 'Freigegeben',
  'ab.status.rejected': 'Abgelehnt',

  // ---- Detailansicht ----
  'ab.detailLoadError': 'Dokument konnte nicht geladen werden',
  'ab.pdfView': 'AB-Vorschau',
  'ab.pdfHide': 'Ausblenden',
  'ab.pdfShow': 'PDF anzeigen',
  'ab.pdfLoading': 'PDF wird geladen…',
  'ab.headerData': 'Kopfdaten',
  'ab.approvedOn': 'Freigegeben am {date}',
  'ab.rejectReasonLabel': 'Ablehnungsgrund',

  // ---- Abgleich gegen Bestellung ----
  'ab.compareTitle': 'Abgleich gegen Bestellung',
  'ab.compareOk': '{n} passend',
  'ab.compareDiff': '{n} abweichend',
  'ab.compareNotFound': '{n} nicht gefunden',
  'ab.compare.state.ok': 'Passend',
  'ab.compare.state.diff': 'Abweichend',
  'ab.compare.state.not_found': 'Nicht gefunden',
  'ab.compare.tooltip': 'AB: {ab} / Bestellung: {po}',

  // ---- Warnungen ----
  'ab.warningsTitle': 'Warnungen',

  // ---- Positionstabelle ----
  'ab.linesTitle': 'Positionen',
  'ab.noLines': 'Keine Positionen erfasst',
  'ab.addLine': 'Position hinzufügen',
  'ab.confirmDeleteLine': 'Wirklich löschen?',
  'ab.field.ebeln': 'Bestellnummer',
  'ab.field.ebelp': 'Bestellposition',
  'ab.field.labnr': 'AB-Nummer',
  'ab.field.matnr': 'Materialnummer',
  'ab.field.mfrpn': 'Hersteller-Teilenr.',
  'ab.field.menge': 'Menge',
  'ab.field.netpr': 'Preis',
  'ab.field.eeind': 'Liefertermin',
  'ab.field.waers': 'Währung',
  'ab.field.supplier': 'Lieferant',

  // ---- Aktionen ----
  'ab.approve': 'Freigeben',
  'ab.approveDialogTitle': 'Auftragsbestätigung freigeben?',
  'ab.approveDialogMsg': 'Die Positionen werden als geprüft markiert. Diese Aktion kann nicht rückgängig gemacht werden.',
  'ab.approvedMsg': 'Auftragsbestätigung freigegeben',
  'ab.reject': 'Ablehnen',
  'ab.rejectDialogTitle': 'Auftragsbestätigung ablehnen',
  'ab.rejectReasonPlaceholder': 'Grund der Ablehnung…',
  'ab.rejectReasonRequired': 'Bitte einen Ablehnungsgrund angeben',
  'ab.rejectedMsg': 'Auftragsbestätigung abgelehnt',
  'ab.reprocess': 'Neu verarbeiten',
  'ab.reprocessDialogTitle': 'Neu verarbeiten?',
  'ab.reprocessDialogMsg': 'Alle Positionen werden gelöscht und per OCR neu erkannt. Manuelle Änderungen gehen dabei verloren.',
  'ab.reprocessedMsg': 'Wird neu verarbeitet',
  'ab.deleteDialogTitle': 'Dokument löschen?',
  'ab.deleteDialogMsg': 'Das Dokument, die Datei und alle Positionen werden unwiderruflich gelöscht.',
  'ab.deletedMsg': 'Dokument gelöscht',
  'ab.lineAddedMsg': 'Position hinzugefügt',
  'ab.lineDeletedMsg': 'Position gelöscht',

  // ---- Verlauf (ab_events) ----
  'ab.timeline': 'Verlauf',
  'ab.event.uploaded': 'Hochgeladen',
  'ab.event.extracted': 'Positionen erkannt',
  'ab.event.line_edited': 'Position bearbeitet',
  'ab.event.line_added': 'Position hinzugefügt',
  'ab.event.line_deleted': 'Position gelöscht',
  'ab.event.reprocessed': 'Neu verarbeitet',
  'ab.event.approved': 'Freigegeben',
  'ab.event.rejected': 'Abgelehnt',
  'ab.event.failed': 'Verarbeitung fehlgeschlagen',
  'ab.event.sap_committed': 'SAP-Buchung erfolgreich',
  'ab.event.commit_failed': 'SAP-Buchung fehlgeschlagen',
  'ab.event.suggest_started': 'KI-Regelset-Vorschlag gestartet',
  'ab.event.suggest_done': 'KI-Regelset-Vorschlag erstellt',
  'ab.event.suggest_applied': 'KI-Regelset-Vorschlag als Entwurf übernommen',

  // ==================== REGELSET-VERWALTUNG (admin) ====================
  'ab.rulesetsButton': 'Regelsets',
  'ab.rulesetsTitle': 'Regelset-Verwaltung',
  'ab.rulesetsLoadError': 'Regelsets konnten nicht geladen werden',
  'ab.rulesetsEmpty': 'Noch keine Regelsets angelegt',
  'ab.rulesetNewVersion': 'Neue Version',
  'ab.rulesetEdit': 'Bearbeiten',
  'ab.rulesetActivate': 'Aktivieren',
  'ab.rulesetDeactivate': 'Deaktivieren',
  'ab.rulesetDeleteActiveHint': 'Die aktive Version kann nicht gelöscht werden — zuerst deaktivieren',
  'ab.rulesetVersion': 'Version {v}',
  'ab.rulesetActivatedMsg': 'Regelset aktiviert',
  'ab.rulesetDeactivatedMsg': 'Regelset deaktiviert',
  'ab.rulesetDeletedMsg': 'Regelset gelöscht',
  'ab.rulesetSavedMsg': 'Regelset als Entwurf gespeichert',
  'ab.rulesetConfirmDeleteTitle': 'Regelset löschen?',
  'ab.rulesetConfirmDeleteMsg': 'Regelset „{supplier}" Version {version} wird unwiderruflich gelöscht.',
  'ab.rulesetSupplierIdLabel': 'Lieferanten-ID',
  'ab.rulesetSupplierNameLabel': 'Lieferantenname',
  'ab.rulesetJsonLabel': 'Regelset (JSON)',
  'ab.rulesetJsonInvalid': 'Ungültiges JSON: {error}',
  'ab.rulesetRequiredFields': 'Bitte Lieferanten-ID, Lieferantenname und gültiges JSON angeben',
  'ab.rulesetPreviewTitle': 'Vorschau',
  'ab.rulesetPreviewDocPlaceholder': '– Dokument wählen –',
  'ab.rulesetPreviewDocRequired': 'Bitte zuerst ein Test-Dokument wählen',
  'ab.rulesetPreviewButton': 'Vorschau ausführen',
  'ab.rulesetPreviewRunning': 'Vorschau läuft…',
  'ab.rulesetPreviewResult': '{lineCount} Position(en) erkannt',
  'ab.rulesetPreviewError': 'Vorschau fehlgeschlagen',
  'ab.rulesetPreviewEmptyHint': 'Dokument wählen und Vorschau ausführen',

  // ==================== KI-REGELSET-VORSCHLAG ====================
  'ab.suggestTitle': 'KI-Regelset vorschlagen',
  'ab.suggestDesc': 'Für diesen Lieferanten ist kein passendes Regelset hinterlegt. Die KI kann anhand des Dokuments einen Regelset-Entwurf vorschlagen.',
  'ab.suggestButton': 'KI-Regelset vorschlagen',
  'ab.suggestStarting': 'Wird gestartet…',
  'ab.suggestRunning': 'KI erstellt einen Regelset-Vorschlag…',
  'ab.suggestNotConfigured': 'KI-Vorschlag ist nicht konfiguriert (LLM-Zugang fehlt)',
  'ab.suggestAdminOnly': 'Der KI-Vorschlag kann nur von Administratoren gestartet werden — bitte wende dich an deinen Admin.',
  'ab.suggestAlreadyRunning': 'Für dieses Dokument läuft bereits ein KI-Vorschlag',
  'ab.suggestTimeout': 'Zeitüberschreitung beim Warten auf das KI-Ergebnis',
  'ab.suggestFailed': 'KI-Vorschlag fehlgeschlagen',
  'ab.suggestRetryButton': 'Erneut versuchen',
  'ab.suggestResultSummary': '{lineCount} Position(en) erkannt',
  'ab.suggestApplyButton': 'Als Entwurf übernehmen',
  'ab.suggestApplyHint': 'Das Regelset wird als inaktiver Entwurf angelegt — bitte in der Regelset-Verwaltung aktivieren und das Dokument anschließend neu verarbeiten.',
  'ab.suggestAppliedMsg': 'KI-Vorschlag als Regelset-Entwurf übernommen',

  // ==================== SAP-COMMIT-ERGEBNIS ====================
  'ab.commitResultTitleSuccess': 'SAP-Buchung erfolgreich',
  'ab.commitResultTitleFailed': 'SAP-Buchung fehlgeschlagen',
  'ab.commitResultFailedHint': 'Der Status bleibt „Zu prüfen" — bitte Fehler beheben und erneut freigeben.',
  'ab.commitResultNoGroups': 'Keine Bestellungen zum Buchen gefunden.',
  'ab.commitLineLabel': 'Position {ebelp}',
  'ab.commitFailedMsg': 'SAP-Buchung fehlgeschlagen',
  'ab.fourEyesTitle': 'Freigabe blockiert',

  // ==================== MAIL-EINGANG (admin) ====================
  'ab.mailEnabledChip': 'Mail-Eingang aktiv ({n})',
  'ab.mailDisabledChip': 'Mail-Eingang aus',
  'ab.mailDisabledHint': 'Mail-Eingang ist deaktiviert (AB_MAIL_ENABLED) — Klick versucht dennoch einen Lauf',
  'ab.mailNoRunYet': 'Noch kein Lauf',
  'ab.mailLastRunTooltip': 'Letzter Lauf {finishedAt}: {found} gefunden, {processed} verarbeitet, {ignored} ignoriert, {failed} fehlgeschlagen',
  'ab.mailSyncStarted': 'Mail-Synchronisierung gestartet',
};

export default ab;
